import React, { useEffect } from 'react'
import MainLayouts from '../../layout/MainLayouts'
import Flyer from '../../assets/images/webinar-code-to-cybersecurity.jpg'

const FORM_ID = 'KltEnBbHaWE3v3B9Gr1L'
const EMBED_SCRIPT = 'https://link.nextaflow.net/js/form_embed.js'

const Events = () => {
  // form_embed.js auto-resizes the iframe to the form's height
  useEffect(() => {
    if (document.querySelector(`script[src="${EMBED_SCRIPT}"]`)) return
    const script = document.createElement('script')
    script.src = EMBED_SCRIPT
    script.async = true
    document.body.appendChild(script)
  }, [])

  return (
    <MainLayouts>
      <section className="bg-[#f7f7f7] px-4 md:px-[7%] pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <p className="text-sm font-bold uppercase tracking-widest text-[#d15424]">Free Webinar</p>
            <h1 className="mt-2 text-3xl md:text-4xl font-extrabold text-[#0b0f19]">
              From Code to Cybersecurity: Build, Protect &amp; Innovate
            </h1>
            <p className="mt-3 text-gray-600">
              Tuesday, 6th October 2026 · 7:00PM WAT / 11:00AM PST · Live on Zoom &amp; YouTube
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 items-start">
            <img
              src={Flyer}
              alt="From Code to Cybersecurity webinar with Adebayo Dawodu, Tuesday 6th October 2026"
              className="w-full rounded-2xl shadow-lg"
            />

            <div className="bg-white rounded-2xl shadow-lg p-2 md:p-4">
              <iframe
                src={`https://link.nextaflow.net/widget/form/${FORM_ID}`}
                style={{ width: '100%', height: '100%', minHeight: 700, border: 'none', borderRadius: 3 }}
                id={`inline-${FORM_ID}`}
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Webinar Registration"
                data-layout-iframe-id={`inline-${FORM_ID}`}
                data-form-id={FORM_ID}
                title="Webinar Registration"
              />
            </div>
          </div>
        </div>
      </section>
    </MainLayouts>
  )
}

export default Events
